export const DEFAULT_NAMESPACE = 'default';

export const MasonryEngineLevelActionNames = ['onLoad'];

export const HIDDEN_SUBTREE_CLASS_NAME = 'hidden-masonry-subtree';

/**
 * DO NOT TRY TO USE THIS QUERY KEY CONSTANT DIRECTLY. USE THE `clearNodeCache` FUNCTION INSTEAD.
 */
export const QUERY_KEY_GET_NODE_ASYNC_SELF =
  'MASONRY_ENGINE_GET_NODE_ASYNC_SELF';

/**
 * Loop detection thresholds.
 */
export const LOOP_PER_NODE_MAX_COUNT = 5;
export const LOOP_WINDOW_MS = 3000;
